import React, { Component } from "react";
import "../../App.css";

class Splitter extends Component {
  state = {
    dragging: false,
    origin_x: 0,
    origin_y: 0,
    first_width: 0,
    first_height: 0,
    second_width: 0,
    second_height: 0,
    border: 60,
  };

  resetDimensions = () => {
    const first = document.getElementById("first");
    const second = document.getElementById("second");
    if (window.innerWidth > 500) {
      var w =
        (first.offsetWidth / (first.offsetWidth + second.offsetWidth)) * 100;
      first.style.width = "calc(" + w + "% - 10px)";
      second.style.width = "calc(" + (100 - w) + "% - 10px)";
      first.style.height = "100%";
      second.style.height = "100%";
    } else {
      var h =
        (first.offsetHeight / (first.offsetHeight + second.offsetHeight)) * 100;
      first.style.height = "calc(" + h + "% - 20px)";
      second.style.height = "calc(" + (100 - h) + "% - 20px)";
      first.style.width = "100%";
      second.style.width = "100%";
    }
  };

  onMouseDown = (e) => {
    const first = document.getElementById("first");
    const second = document.getElementById("second");
    this.setState({
      dragging: true,
      origin_x: e.clientX,
      origin_y: e.clientY,
      first_width: first.offsetWidth,
      first_height: first.offsetHeight,
      second_width: second.offsetWidth,
      second_height: second.offsetHeight,
    });
  };

  onMouseMove = (event) => {
    var {
      origin_x,
      origin_y,
      dragging,
      first_width,
      first_height,
      second_width,
      second_height,
      border,
    } = this.state;
    if (dragging) {
      const first = document.getElementById("first");
      const second = document.getElementById("second");
      var delta;
      if (event.type === "touchmove") {
        delta = {
          x: event.touches[0].clientX - origin_x,
          y: event.touches[0].clientY - origin_y,
        };
      } else {
        delta = {
          x: event.clientX - origin_x,
          y: event.clientY - origin_y,
        };
      }
      if (window.innerWidth > 500) {
        if (first_width + delta.x < border) {
          first.style.width = border + "px";
          second.style.width = window.innerWidth - 10 - border + "px";
        } else if (second_width - delta.x < 300) {
          first.style.width = window.innerWidth - 10 - 300 + "px";
          second.style.width = 300 + "px";
        } else {
          first.style.width = first_width + delta.x + "px";
          second.style.width = second_width - delta.x + "px";
        }
      } else {
        if (first_height + delta.y < border) {
          first.style.height = border + "px";
          second.style.height = window.innerHeight - 40 - border + "px";
        } else if (second_height - delta.y < border) {
          first.style.height = window.innerHeight - 40 - border + "px";
          second.style.height = border + "px";
        } else {
          first.style.height = first_height + delta.y + "px";
          second.style.height = second_height - delta.y + "px";
        }
      }
      this.props.update();
      window.dispatchEvent(new Event("resize"));
    }
  };

  onMouseUp = () => {
    this.setState({ dragging: false, origin_x: 0, origin_y: 0 });
  };

  componentDidMount() {
    window.addEventListener("resize", this.resetDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.resetDimensions);
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="splitter"
          onPointerUp={this.onMouseUp}
          onPointerMove={this.onMouseMove}
          onTouchMove={this.onMouseMove}
          onTouchEnd={this.onMouseUp}
        >
          <div id="first">{this.props.first}</div>
          <div id="separator" onPointerDown={this.onMouseDown}></div>
          <div id="second">{this.props.second}</div>
        </div>
      </React.Fragment>
    );
  }
}

export default Splitter;
